module.exports = __webpack_public_path__ + "static/img/bg.4c244de4.jpg";